import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import {
  Box,
  Grid,
  styled,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { theme } from 'src/utils';

export const CustomTableCell = styled(TableCell)<{ isdoublewidth: string }>`
  width: 10px;
  font-size: 16px;

  & a {
    color: inherit;
  }
`;

export const TableHeadCell = styled(Box)`
  display: flex;
  border: none;
  justify-content: start;
  align-items: center;
  gap: 20px;
`;

export const SortIcons = styled(Box)`
  width: 14px;
  height: 31px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 0px;
`;

export const ArrowIcon = styled(Box)`
  height: 20px;
  cursor: pointer;
`;

export const KeyboardArrowUpIconStyled = styled(KeyboardArrowUpIcon, {
  shouldForwardProp: (prop: any) => {
    return prop !== 'active';
  },
})<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>(({ active, theme }) => ({
  color: active ? theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const KeyboardArrowDownIconStyled = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: (prop: any) => {
    return prop !== 'active';
  },
})<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>(({ active, theme }) => ({
  color: active ? theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const CustomTableRow = styled(TableRow)(
  ({ theme }) => `
       border-bottom: 1px solid ${theme.palette.brand.disable};
      `,
);

export const TableBodyContainer = styled(TableContainer)`
  height: ${({ height }: { height: string }) => height};
  overflow: auto;
`;

export const InViewBoxContainer = styled(Box)`
  height: 50px;
`;

export const ButtonWrapper = styled(Box)`
  position: fixed;
  right: 30px;
  top: 30px;
`;

export const StyledGridContainer = styled(Grid)({
  width: '100%',
});

export const StyledGridItem = styled(Grid)({
  width: '50%',
});
export const StyledTooltipContainer = styled('div')({
  width: '300px',
});

export const StyledGridItemLastChild = styled(Grid)({
  marginLeft: 'auto',
});

export const PublicationStatusChip = styled(DynamicTooltipChip)(
  ({ theme, status }) => {
    let backgroundColor;
    let color;

    switch (status) {
      case 'success':
        backgroundColor = theme.status.success.light;
        color = theme.palette.brand.parsley;
        break;
      case 'error':
        backgroundColor = theme.status.danger.light;
        color = theme.palette.brand.red;
        break;
      case 'warning':
        backgroundColor = theme.status.warning.light;
        color = theme.palette.brand.yellow;
        break;
      case 'info':
        backgroundColor = theme.palette.brand.lightBlue;
        color = theme.palette.brand.blue;
        break;
      default:
        backgroundColor = theme.palette.grey;
        color = theme.palette.text.primary;
    }

    return `
        background-color: ${backgroundColor};
        color: ${color};
      `;
  },
);

export const StatusContainer = styled(Typography)(
  ({ isOnline }: { isOnline: boolean }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: isOnline
      ? theme.palette.brand.parsley
      : theme.palette.brand.darkGrey,
  }),
);

export const StatusDot = styled(Box)(({ isOnline }: { isOnline: boolean }) => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: isOnline
    ? theme.palette.brand.parsley
    : theme.palette.brand.darkGrey,
  marginRight: '3px',
}));

export const OfflineStatusContainer = styled(Typography)({
  marginLeft: '5px',
  fontSize: '12px',
  color: theme.palette.brand.darkGrey,
});

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;
`;

export const FooterContainer = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 400px;
  right: 0;
  background-color: white;
  padding: 10px 20px;
  gap: 1rem;
  display: flex;
  justify-content: end;
  z-index: 1000;
`;
